import React from 'react';
import { BetCountOverview } from '../BetCountOverview';

export const SysAdminOverview: React.FC = () => {
    return <BetCountOverview />;
};
